import { FunctionComponent } from 'preact';
import { route, RoutableProps } from 'preact-router';
import { Layout } from '../components/layout';

export const MfaSetupDonePage: FunctionComponent<RoutableProps> = () => {
  return (
    <Layout title="Zwei-Faktor aktiv" subtitle="Zwei-Faktor erfolgreich aktiviert.">
      <button class="btn mt-md" onClick={() => route('/tkw', true)}>
        Weiter zum TKW-Generator
      </button>
    </Layout>
  );
};
